@if (asDropdownTemplate()) {
  <div (click)="$event.preventDefault()">
    <ng-container *ngTemplateOutlet="content" />
  </div>
} @else {
  <rt-dropdown [width]="DropdownWidth.LargeXX" (click)="$event.preventDefault()">
    <ng-container *ngTemplateOutlet="content" />
  </rt-dropdown>
}

<ng-template #content>
  @if (isEvaluationFormsEntitled()) {
    @switch (stepService.step()) {
      @case (Step.Selection) {
        <rt-add-evaluation-selection-step
          [canManageInterviewTemplates]="canManageInterviewTemplates()"
          [loading]="loading()"
          [recommendedTemplate]="recommendedTemplate()"
          [showBackButton]="hasBackAction()"
          (goToEvaluation)="stepService.setStep(Step.AddEvaluation)"
          (goToQuickEvaluation)="onAddQuickEvaluation()"
          (goToRecommendedEvaluation)="onAddRecommendedEvaluation()"
          (goBack)="goBack.emit()"
        />
      }
      @case (Step.AddEvaluation) {
        <rt-add-evaluation-step
          [offers]="offers()"
          (back)="stepService.setStep(Step.Selection)"
          (close)="close.emit()"
          (submit)="addEvaluation.emit($event)"
        />
      }
    }
  }
</ng-template>
